<template lang="pug">
  .contentpage
    .header-area(v-if="areas.header && areas.header.length")
      section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
        Banner(v-if="section.key === 'banner'" :section="section")
        Slider(v-if="section.key === 'slider'" :section="section")
        VideoBanner(v-if="section.key === 'video-banner'" :section="section")
    .main-area.oneCol(v-if="areas.main && areas.main.length")
      section(v-for="(section, index) in areas.main" :key="section.id" :class="section.key")
        Heading.container.mx-auto(v-if="section.key === 'heading'" :section="section")
        Post.container.mx-auto(v-if="section.key === 'post'" :section="section")
        Post2Cols.container.mx-auto(v-if="section.key === 'post-2cols'" :section="section")
        LoginForm.container.mx-auto(v-if="section.key === 'login'" :section="section")
        Form.container.mx-auto(v-if="section.key === 'form'" :section="section")
        CategoryPosts(v-if="section.key === 'categoryposts'" :section="section")
        PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
        Downloads(v-if="section.key === 'downloads'" :section="section")
        ImageSection(v-if="section.key === 'image'" :section="section")
        DividingLine(v-if="section.key === 'dividingLine'", :section="section")
        Video(v-if="section.key === 'videostreaming'", :section="section")
        Banner(v-if="section.key === 'banner'" :section="section")
        Slider(v-if="section.key === 'slider'" :section="section")
        VideoBanner(v-if="section.key === 'video-banner'" :section="section")
        MapBox(v-if="section.key === 'mapbox'", :section="section")
        KeyIcons(v-if="section.key === 'keyIcons'", :section="section")
        .container.mx-auto
            ProductList(
                v-if="section.key === 'categoryproducts'",
                :section="section",
                :key="section.id",
                default-orientation="horizontal"
            )
</template>

<script>
import Page from '@/views/Page';

import Heading from '@/components/Heading';
import Post from '@/components/Post';
import Post2Cols from '@/components/Post2Cols';
import Banner from '@/components/Banner';
import Slider from '@/components/Slider';
import VideoBanner from '@/components/VideoBanner';
import LoginForm from '@/extensions/restricted-area/components/LoginForm';
import Form from '@/components/Form';
import CategoryPosts from '@/components/CategoryPosts';
import PhotoAlbum from '@/components/PhotoAlbum';
import Downloads from '@/components/Downloads';
import DividingLine from '@/components/DividingLine';
import Video from '@/components/Video';
import ImageSection from '@/components/ImageSection';
import ProductList from '@/extensions/shop/components/ProductList';
import MapBox from '@/components/MapBox';
import KeyIcons from '@/components/KeyIcons';

export default {
    name: 'ContentPage',
    extends: Page,
    components: {
        Heading,
        VideoBanner,
        Slider,
        Post,
        Post2Cols,
        Banner,
        LoginForm,
        Form,
        CategoryPosts,
        PhotoAlbum,
        Downloads,
        DividingLine,
        Video,
        ImageSection,
        MapBox,
        KeyIcons,
        ProductList
    }
};
</script>

<style lang="sass" scoped>
.main-area.oneCol > section
  @apply mb-8 mt-8
  @screen lg
      &:first-of-type
        @apply mt-16

.main-area.oneCol section.categoryposts
  @apply mt-0

.main-area.oneCol section.homepage-gallery
  @apply mt-10
  &:last-of-type
    margin-bottom: -25px
</style>
